module.exports = __webpack_public_path__ + "static/media/fitness-video-img.c83dc045.jpg";